 import { createSlice } from '@reduxjs/toolkit';

 const loadUserFromLocalStorage = () => {
  const userData = localStorage.getItem('userInfo');
  return userData ? JSON.parse(userData) : null;
};

const initialState = {
  userInfo: loadUserFromLocalStorage(),  
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.userInfo = action.payload;
      localStorage.setItem('userInfo', JSON.stringify(action.payload));  
    },
    clearUser: (state) => {
      state.userInfo = null;
      localStorage.removeItem('userInfo'); 
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
